import React from 'react';

interface Props {
  country?: string;
}

const Terms = ({ country }: Props) => (
  <>
    {(country === 'BR' || country === '55') && (
      <>
        <h1>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA “NETACTICA CORPORATE”</h1>
        <br />
        <br />
        <b>1. INFORMAÇÕES GERAIS</b>
        <br />
        <p>
          RAPPI AGÊNCIA DE VIAGENS E TURISMO LTDA, CNPJ: 35.506.356/0001-86, com constituída na cidade de São Paulo,
          para os efeitos destes termos será definida como A OPERADORA. A OPERADORA é uma agência de viagens devidamente
          inscrita junto ao Ministério de Turismo, CADASTUR Ministério do Turismo sob o nº 35.506.356/0001-86, e sua
          atividade está regulamentada pela Lei de Agências de Viagens n.º 12.974, de 15 de maio de 2014.
        </p>
        <p>
          O simples uso da Plataforma implica na aceitação de todas e quaisquer condições gerais e particulares
          incluídas nestes termos e condições. Sua leitura lhe permitirá exercer da melhor maneira seus direitos como
          consumidor. Sugerimos imprimi-las e guardá-las junto com o restante da documentação de sua viagem. Lembre-se
          de tomar nota do número do Pedido de Compra que aparecerá na tela ao confirmar seu pedido.{' '}
        </p>
        <p>
          Estas condições são as de caráter geral que são aplicadas aos serviços de intermediação prestados e, sob
          nenhum aspecto, substituem ou alteram as limitações de responsabilidade legalmente estabelecidas, nem as
          condições especiais que cada Fornecedor tenha definido para seus Serviços. Antes de contratar, revise as
          condições particulares de cada Serviço e de cada Fornecedor. Não temos gerência nas condições particulares
          estabelecidas por cada Fornecedor para a prestação dos seus Serviços e, consequentemente, não podemos
          alterá-las ou arcar com qualquer responsabilidade delas decorrentes
        </p>
        <p>
          A OPERADORA é uma agência de viagens on-line, cuja plataforma tecnológica permite a uma grande quantidade de
          prestadores de serviços turísticos (o(s) “Fornecedor(es)”) oferecer e comercializar seus serviços aos
          usuários, que, por sua vez, podem procurar informações sobre passagens e reserva de hospedagem. A OPERADORA
          não é o fornecedor dos Serviços Turísticos e atua apenas como intermediadora dos produtos oferecidos pelos
          Fornecedores, não sendo, portanto, obrigada, direta ou indiretamente, a executar o Serviço Turístico, tampouco
          responsável por qualquer falha na prestação de serviços prestados pelos Fornecedores, ou quaisquer danos
          causados por culpa exclusiva dos Fornecedores. Na compra de passagem ou na reserva de acomodações, o usuário
          está celebrando um contrato diretamente com o Fornecedor, sendo realizada a mera intermediação pela OPERADORA.
        </p>
        <p>
          Ao contratar Serviços através da OPERADORA, o usuário garante que: (i) é civilmente capaz; (ii) aceita
          expressamente estes Termos e Condições; (iii) só utiliza a Plataforma para reservar ou contratar Serviços
          Turísticos para o próprio usuários e/ou para outra pessoa em nome da qual tenha autorização para atuar; (iv)
          no caso de adquirir serviços com destino/escala em Cuba, não é cidadão nem residente dos Estados Unidos da
          América e nem está sujeito à jurisdição dos Estados Unidos; e (vi) toda informação que fornece à OPERADORA é
          verídica, exata, atual e completa.
        </p>
        <p>
          As informações publicadas na Plataforma relativas aos preços, qualidades e características dos são
          estabelecidas e oferecidas diretamente pelos Fornecedores e em tempo real e sem qualquer ingerência (direta ou
          indireta) da OPERADORA.{' '}
        </p>
        <b>2. SERVIÇOS</b>
        <p>
          A OPERADORA exibe através da Plataforma os produtos e serviços que estão à disposição dos usuários para serem
          adquiridos
        </p>
        <p>
          Antes de confirmar a sua solicitação de compra, clicando no botão Comprar e mediante prévia aceitação destes
          Termos e Condições, é de suma importância que o usuário tenha compreendido os termos e condições particulares
          aplicáveis ao Serviço que deseja contratar, que são estabelecidos pelo respectivo Fornecedor e devidamente
          informados na página de apresentação de tal serviço. Assim evitará surpresas e poderá desfrutar de sua viagem
          como planejou. As políticas de cada Serviço são estabelecidas exclusivamente por cada Fornecedor.{' '}
        </p>
        <p>
          Após o envio do Pedido de Compra através da Plataforma, o usuário autoriza a OPERADORA a gerenciar sua reserva
          e a cobrar o(s) respectivo(s) encargo(s) na sua conta ou no seu cartão. Preste muita atenção às nossas
          mensagens posteriores, nas quais iremos lhe informando sobre as etapas e situação do seu Pedido de Compra. A
          conclusão da gestão da reserva e/ou da confirmação da compra dependem do pagamento integral e oportuno do
          preço e/ou tarifa de todos os Serviços. Enquanto não houver confirmação do pagamento total da reserva, o
          Pedido de Compra ficará suspenso e poderá ser cancelado pelo Fornecedor. A confirmação definitiva dos Serviços
          e dos respectivos preços será realizada mediante a emissão do(s) ticket(s) eletrônico(s) ou com o envio do
          voucher, o que for aplicável, e sua fatura. Além disso, nas operações de crédito, deverão ser preenchidos os
          requisitos próprios fixados pelo seu banco emissor. A emissão do ticket eletrônico ou voucher, o que for
          aplicável, confirma expressa e inequivocamente a aceitação das condições do Fornecedor e da celebração do
          contrato assinado entre o Fornecedor e a pessoa cujo(s) nome(s) aparece(m) no referido ticket eletrônico e/ou
          voucher.
        </p>
        <p>
          Se o Pedido de Compra ficar sujeito a confirmação, circunstância que lhe será informada no primeiro correio
          eletrônico que receber, os valores pagos antes da confirmação serão recebidos a título de reserva. Se, por
          fim, seu Pedido de Compra for rejeitado por qualquer motivo (por exemplo, por saldo insuficiente no seu cartão
          de crédito, por falta de disponibilidade, por variação na tarifa etc.) a OPERADORA lhe informará sobre as
          opções disponíveis caso o usuário desejar insistir na compra ou na reserva ou, a seu pedido, lhe devolverá os
          valores pagos.
        </p>
        <p>
          Se, após a entrada do seu Pedido de Compras, não receber um e-mail com a informação de compra, revise a pasta
          de Spam e/ou entre em “Minha Conta/Minha Reserva ou em Minhas Viagens” na Plataforma com o número do Pedido de
          Compra. Ali, o usuário poderá realizar gestões e, no caso de dúvidas adicionais, poderá ligar para os números
          de telefones que constam na Plataforma.
        </p>
        <b>3. DADOS NECESSÁRIOS</b>
        <br />
        <b>3.1.DADOS PESSOAIS</b>
        <p>
          O USUÁRIO deverá preencher todos os campos com dados exatos para poder realizar reservas válidas de Serviços
          através da Plataforma. Ao entrar com seus dados pessoais na Plataforma, o usuário declara que os referidos
          dados (os “Dados Pessoais”) são exatos, precisos e verdadeiros, e assume o compromisso de atualizar os
          referidos Dados Pessoais conforme for necessário. Você garante e se responsabiliza pela veracidade, exatidão,
          vigência e autenticidade dos Dados Pessoais inseridos. Lembre-se que todos os seus dados deverão coincidir de
          forma exata com a Documentação de viagem.
        </p>
        <p>
          O endereço de e-mail no item “Dados de Contato” é a nossa via de contato com o usuário. O e-mail deverá ser
          mantido atualizado e o usuário deverá se manter atento as informações que serão enviadas pelo referido
          correio.{' '}
        </p>
        <p>
          Considerar-se-á que o usuário tomou conhecimento oportuno da confirmação de seu Pedido de Compra ou de algum
          inconveniente ou alteração do mesmo mediante envio da referida informação será realizada através do endereço
          de e-mail fornecido. Leve em conta que se o endereço de e-mail fornecido contiver algum erro, você deixará de
          receber comunicações fundamentais para o gerenciamento do seu Pedido de Compra.
        </p>
        <b>3.2.DADOS PARA FATURAMENTO </b>

        <p>
          Os dados pessoais e fiscais deverão ser incluídos com exatidão para poder emitir o comprovante fiscal
          correspondente. Ao incluir os dados, o usuário declara que os referidos dados são exatos, precisos e
          verdadeiros, de forma que a OPERADORA não será responsável pela emissão de documentos com informação incorreta
          fornecida pelo usuário, estando sujeitos a Política de Privacidade da Plataforma Rappi, podendo ser
          compartilhado os dados pessoais com o estabelecimento envolvido em seu Pedido de Compra, a fim de efetivação
          de sua reserva e portanto execução do objeto da compra.
        </p>
        <b>3.3.DOCUMENTOS DE VIAGEM</b>
        <p>
          O USUÁRIO tem o dever de informar-se de forma responsável sobre a documentação legal e/ou migratória e/ou as
          exigências sanitárias que podem ser necessárias para poder realizar sua viagem conforme o planejado (a
          “Documentação de Viagem”). Lembre-se que é responsabilidade do usuário cumprir com todos os requisitos e/ou
          documentação de entrada e/ou de trânsito que forem exigidos pelas autoridades migratórias, aduaneiras e/ou
          sanitárias do(s) País(es) de destino(s) e/ou trânsito
        </p>
        <p>
          Sem prejuízo do mencionado anteriormente, lembramos que: (i) os residentes dos Países membros do Mercosul
          poderão transladar com o DNI Digital (ou o Passaporte) aos Países membros do Mercosul (Argentina, Brasil,
          Bolívia, Paraguai, Uruguai e Venezuela) e Estados Associados (Chile, Colômbia, Equador e Peru). No caso de
          viajar a outros Países, é necessário levar o Passaporte e (ii) os residentes estrangeiros podem viajar às
          Nações sul-americanas mencionadas com o Documento Nacional de Identidade ou o Passaporte de seu País.
          Verifique com antecedência a data do vencimento da documentação e leve em consideração que, em alguns Países,
          exige-se que a data de expiração não seja inferior a seis meses da data da chegada ao território estrangeiro
        </p>
        <p>
          No caso de viajar com menores de 18 anos, além do documento de viagem habilitado (DNI Digital ou Passaporte),
          são necessárias autorizações de acordo com as diferentes considerações: (i) Se o menor estiver viajando com
          ambos os pais, basta que se comprove o vínculo mediante Caderneta Civil de Família ou Certidão de Nascimento
          (sem importar a data de sua emissão) ou o DNI do menor, onde constem os dados de filiação, (ii) se viajar
          somente com um dos pais, além de demonstrar a relação parental com algum dos documentos mencionados, deverá
          vir acompanhado da autorização da mãe ou do pai ausente com firma reconhecida, sem prejuízo de obtenção de
          ordem judicial, quando aplicável e (iii) se for filho de menores, necessitará a autorização dos pais e a
          autorização correspondente de um dos avós. Sem prejuízo disso, revise a Documentação de viagem necessária
          conforme o tipo de transporte, o Fornecedor e a origem e/ou destino do transporte, uma vez que os requisitos
          poderão variar em caso de viagem por mar, terra ou ar e de acordo com cada Fornecedor. No caso de o(s)
          menor(es) não viajar(em) acompanhado(s) de um maior responsável, por favor, revise as políticas de menor
          desacompanhado de cada Fornecedor.
        </p>
        <b>4. VALORES E PAGAMENTOS</b>
        <p>
          Quando da reserva de um Serviço Turísticos através da Plataforma, o usuário deve pagar (i) o preço ou a tarifa
          fixado pelo Fornecedor; (ii) os impostos, taxas e/ou emolumentos aplicáveis ao Serviço e, caso corresponda,
          (iii) o encargo de gerenciamento pelo serviço de intermediação da OPERADORA (o “Encargo de Gerenciamento”,
          também podendo ser chamado na Plataforma de “Taxa de Serviço”). Os valores correspondentes ao preço ou tarifa
          dos Serviços Turísticos são transferidos (endossados) ao Fornecedor. Os meios e formas de pagamento
          disponíveis para cada Serviço são os informados na Plataforma de maneira prévia à elaboração do seu Pedido de
          Compra.
        </p>
        <p>
          Se efetuar uma reserva na opção parcelada e/ou mediante um cartão de crédito, o usuário deve levar em
          consideração que o Encargo de Gerenciamento poderá ser aplicado integralmente na primeira parcela, apesar de
          ter feito a opção de pagamento parcelado para o restante do preço ou tarifa. Os juros e/ou impostos que vierem
          a ser gerados pelo pagamento em parcelas são somados ao preço ou tarifa proposto para o serviço e o referido
          total é dividido pela quantidade de parcelas selecionadas para pagamento.
        </p>
        <p>
          Se tiver combinado com seu emissor de cartão de crédito seguros de vida pelo saldo devedor ou outros encargos
          que afetem o custo financeiro total, lembre-se de consultar sua empresa emissora sobre a vigência, condições e
          custos de tais seguros ou encargos, os quais, naturalmente, nada têm a ver com a OPERADORA e dependem e/ou
          variam conforme o que foi combinado com cada agente emissor ou operadora de cartões de crédito. Recomendamos
          que se informe sobre as condições de uso e dos juros de seu cartão de crédito antes de utilizar da modalidade
          de pagamento em parcelas
        </p>
        <p>
          O preço a pagar poderá ser cobrado em moeda nacional ou em dólares, conforme se tratar de prestações locais ou
          estrangeiras. Caso seja cobrado em dólares, o lançamento será efetuado contra o limite internacional do seu
          cartão. Em todo caso, qualquer que seja a moeda de pagamento, a tarifa ou preço será aquele que lhe foi
          informado e aceito. Lembre-se de que para as operações internacionais, alguns bancos e empresas operadoras de
          cartões de crédito impõem certos encargos, além de impostos correspondentes de acordo com a lei estrangeira
          aplicável. Adicionalmente, seu banco poderá converter os preços à moeda local e cobrar um valor pela
          conversão. Pode acontecer de o tipo de câmbio utilizado pelo Banco ser distinto do apresentado pela
          Plataforma, sendo que o usuário poderá perceber uma variação entre o valor cobrado pelo banco e o valor
          informado na Plataforma. O banco é quem determina o tipo de câmbio e a tarifa aplicada na sua reserva,
          informe-se junto ao seu banco.
        </p>
        <p>Cada transação está sujeita a processos de verificação antifraude.</p>
        <b>5. DESISTÊNCIA</b>
        <p>
          Observando-se a legislação aplicável ao produto adquirido e as regras dos Fornecedores, o exercício do direito
          de arrependimento deve observar o prazo de 07 (sete) dias contados a partir da celebração do contrato. Para
          exercer este direito, o usuário deverá comunicar a OPERADORA tempestivamente acerca de sua decisão, por
          escrito ou mediante meios eletrônicos através do canal de atendimento da Plataforma. A OPERADORA realizará as
          gestões de apresentação e acompanhamento de sua solicitação perante o Fornecedor, e, no caso de o Fornecedor
          ter sido pago, será o Fornecedor quem deverá proceder à devolução do seu dinheiro, mediante um crédito ou um
          estorno de valores no seu cartão de crédito. Se o pagamento tiver sido efetuado mediante transferência
          bancária, poderemos solicitar novamente seus dados para poder gerenciar o reembolso através desse meio.{' '}
        </p>
        <p>
          Sobre este item, informamos que Artigo 49. Do Código de Defesa do Consumidor - O consumidor pode desistir do
          contrato, no prazo de 7 dias a contar de sua assinatura ou do ato de recebimento do produto ou serviço, sempre
          que a contratação de fornecimento de produtos e serviços ocorrer fora do estabelecimento comercial,
          especialmente por telefone ou a domicílio.
        </p>
        <p>
          Sem prejuízo do que foi explicado no parágrafo anterior, leve em consideração que o transporte comercial no
          Brasil é regido por um conjunto de normas, entre as quais se encontram a Resolução 400 da Agência Nacional da
          Aviação Civil e as Normas Internacionais da IATA, (International Air Transport Association) (As “Normas
          Aeronáuticas”).
        </p>
        <p>
          Essas normas trazem regramento especifico sobre o Direito de Arrependimento, motivo pelo qual fica a cargo das
          companhias aéreas estabelecer livremente as condições de cancelamento, o que acontece sem a intervenção da
          OPERADORA. A Resolução 400 da Agência Nacional da Aviação Civil estabelece que o usuário poderá exercer o
          Direito de Arrependimento desde que o faça no prazo de 24 (vinte e quatro) horas da realização da compra,
          sendo certo que as companhias aéreas podem determinar em suas condições de cancelamento que esta regra somente
          se aplicam para compras feitas com antecedência igual ou superior a 07 (sete) dias em relação á data do
          embarque. Por isso, consulte as condições estabelecidas pela companhia aérea antes da aquisição de seu bilhete
          aéreo.
        </p>
        <b>5.1.ALTERAÇÕES EM PEDIDOS</b>
        <p>
          Ao solicitar uma alteração ou cancelamento fora dos prazos e procedimentos explicados no item anterior, e a
          regulamentação específica da tarifa selecionada assim o permitir, a OPERADORA realizará as gestões de
          apresentação e acompanhamento de sua solicitação, mas, tanto os prazos de resposta como a decisão final, serão
          do Fornecedor. Se a data da execução do serviço estiver próxima, a OPERADORA não pode garantir que o
          Fornecedor emitirá uma solução da questão. A maneira de proceder e as condições especiais vigentes para esses
          casos de trocas ou cancelamentos em uma reserva confirmada são determinadas pelos Fornecedores, que poderão
          estabelecer multas ou penalidades aplicáveis para as alterações solicitadas.
        </p>
        <p>
          Revise as condições antes de reservar e lembre-se de que existem Serviços Turísticos nos quais, por disposição
          dos Fornecedores, não se admitem alterações e/ou devoluções, ou se admitem mediante restrições e/ou
          penalidades, inclusive em casos de doença, greves, fenômenos climáticos etc.
        </p>
        <p>
          Quando uma alteração é solicitada, a reserva confirmada é cancelada e outra reserva é solicitada. Desta forma
          a nova reserva será regida pelas condições particulares aplicáveis no momento da alteração. Portanto, além das
          penalidades aplicáveis, poderá existir uma diferença de tarifa que consiste em um valor que resulta da
          diferença da tarifa originalmente paga e a nova tarifa, conforme a disponibilidade tarifária no momento de
          realização da troca (a “Diferença Tarifária”). Lembre-se de que as tarifas turísticas são dinâmicas e dependem
          de variáveis, como antecedência de compra, datas de viagem, promoções de estação e, no caso de voos, também
          das restrições tarifárias (quanto maiores as restrições, maior o preço).
        </p>
        <p>
          No caso de devoluções aprovadas pelo Fornecedor, estas poderão ser efetuadas mediante um crédito ou estorno de
          valores no mesmo cartão com o qual foi feita a reserva, mediante prévia autorização do(a) titular do cartão de
          crédito. Se o pagamento foi realizado à vista, em dinheiro, e/ou transferência bancária, a OPERADORA
          solicitará seus dados bancários para realizar o reembolso mediante transferência bancária. Os prazos de
          reembolso e/ou do estorno de valores dependerão de cada Fornecedor (nos casos das Companhias Aéreas estima-se
          habitualmente de 30 a 120 dias).
        </p>
        <p>
          Cabe esclarecer que os Fornecedores não são obrigados a realizar exceções das condições do contrato aos
          passageiros, mesmo nos casos comprovados de doença ou incapacidade física que lhes impeça de viajar. Ou seja,
          se a tarifa ofertada previr a cobrança de penalidade para realizar alterações/devoluções ou não permitir
          alterações e/ou devoluções, o Fornecedor poderá cobrar esses valores ou negar a devolução do custo da reserva
        </p>
        <p>
          O Valor de Gerenciamento cobrado pela OPERADORA é de caráter não reembolsável. No caso de cancelamento de
          reservas confirmadas por qualquer motivo, o referido valor não será devolvido, já que corresponde a um serviço
          efetivamente prestado. Da mesma forma, na hipótese de alteração ou cancelamento de um Serviço, poderá ser
          cobrado um Valor de Gerenciamento adicional.
        </p>
        <p>
          Caso realize um cancelamento posterior à compra, sempre que as condições particulares do Serviço Turístico
          assim o permitam, a OPERADORA não devolverá e nem será responsável pelos juros que a transação original tiver
          gerado, uma vez que a OPERADORA não recebe esses referidos juros.
        </p>
        <b>5.2.NO SHOW</b>
        <p>
          No caso de não apresentação para utilizar sua reserva nas datas e horários indicados (ou chegar com atraso)
          configura-se o que no mercado turístico conhece como “No Show”. Neste caso, o usuário não terá o direito de
          exigir a devolução total ou parcial do valor pago. Se não for utilizar sua reserva no todo ou em parte ou se
          for chegar com atraso para utilizar a sua reserva, recomendamos comunicar-se previamente com o Fornecedor e
          com a OPERADORA para conhecer as restrições aplicáveis.
        </p>
        <p>
          É importante levar em consideração que o transporte comercial no Brasil é regido por um conjunto de normas
          entre as quais se encontra a Resolução 400 da Agência Nacional da Aviação Civil. Essas normas trazem
          regramento especifico sobre o “No Show”, motivo pelo qual fica a cargo das companhias aéreas estabelecer
          livremente as condições de cancelamento, o que acontece sem a intervenção da OPERADORA
        </p>
        <b>6. CONDIÇÕES ESPECIAIS A PRODUTOS TURÍSTICOS COM DESTINO A CUBA</b>
        <p>
          Conforme as regulamentações vigentes nos Estados Unidos, as viagens a Cuba para atividades turísticas são
          proibidas para cidadãos, residentes ou pessoas sujeitas à jurisdição norte-americana. Esta regra tem algumas
          exceções (como por exemplo: visitas familiares; trabalho oficial para o Governo dos Estados Unidos, Governos
          Estrangeiros e algumas organizações não governamentais; atividade jornalística; pesquisa e reuniões
          profissionais etc.). Atualmente aOPERADORA não conta com os recursos para poder verificar estas exceções
          durante o processo de compra “on-line”. Portanto, momentaneamente não temos condições de oferecer este destino
          aos cidadãos compreendidos nas referidas exceções.{' '}
        </p>
        <b>7. DEVERES DA OPERADORA</b>
        <p>
          A OPERADORA não é responsável direta ou indiretamente pelas perdas e danos que por qualquer modo o usuário ou
          aqueles que viajam com este possam sofrer antes, durante ou como consequência do destino escolhido. A
          OPERADORA não se responsabiliza por eventos relacionados com caso fortuito, força maior, fato do príncipe e
          condutas intrínsecas praticadas pelo usuário ou aqueles que viajam com este, que possam acontecer antes ou
          durante a Prestação do Serviço, e que possam eventualmente atrasar, interromper ou impedir a execução do
          mesmo.
        </p>
        <p>
          A OPERADORA reserva o direito de atualizar, modificar e/ou descontinuar os produtos exibidos na Plataforma a
          qualquer momento, sem necessitar de qualquer aviso prévio.
        </p>
        <b>8. CONSULTAS OU RECLAMAÇÕES</b>
        <p>
          Caso precise efetuar uma reclamação ou consulta, solicitar alterações e/ou cancelamentos – sempre que sua
          tarifa assim o permitir – solicitar o reenvio de vouchers ou tickets e/ou fazer o download de sua fatura, o
          usuário poderá acessar durante as 24 horas do dia o link “Minha Conta” se estiver registrado na Plataforma (ou
          através de “Minha Reserva” ou “Minhas Viagens”) com o seu número do Pedido de Compra, onde poderá realizar
          qualquer gestão. Independente disso, para qualquer urgência, sempre poderá utilizar as linhas telefônicas que
          constam nos e-mails ou vouchers enviados
        </p>
        <p>
          Caso queira realizar uma reclamação, sugestão ou consulta, recomenda-se realizar uma descrição detalhada dos
          fatos, juntando imediatamente uma cópia dos comprovantes do alegado, explicando o ocorrido e formulando em
          termos claros e simples a solução desejada. Desta maneira poderemos revisar seu caso de forma mais rápida e
          eficiente. A OPERADORA analisará a reclamação e dará resposta através do mesmo endereço de e-mail informado
          por você o quanto antes. Se, da revisão dos comprovantes resultar o acolhimento total ou parcial da sua
          reclamação, a OPERADORA o notificará e lhe enviará por e-mail o acordo correspondente. O referido acima é sem
          prejuízo de que a OPERADORA poderá lhe oferecer uma solução alternativa, diferente dos pedidos formulados pelo
          usuário.
        </p>
        <b>9. ALTERAÇÕES AOS TERMOS E CONDIÇÕES</b>
        <p>
          A OPERADORA poderá modificar autonomamente e em qualquer momento os aspetos formais, procedimentais ou
          substanciais destes Termos e Condições de uso da Plataforma, que serão atualizados e colocados à disposição
          dos usuários na Plataforma, sendo a última versão publicada aquela que regulará as relações comerciais que
          sejam geradas no momento em que a transação for realizada. Assim também, conta com plena autonomia para
          modificar os usos da Plataforma permitidos aos usuários, com o único dever de informá-lo por um meio virtual
          que permita sua publicação e comunicação ao público.
        </p>
        <b>10. CANCELAMENTO E SUSPENSÃO DE CONTA</b>
        <p>
          A OPERADORA se reserva no direito de cancelar, suspender, desativar, bloquear ou, encerrar unilateralmente o
          acesso do usuário aos Serviços, com rescisão unilateral do presente contrato, com ou sem aviso prévio, caso:
          (i) seja identificada qualquer violação as normas jurídicas (ii) suas ações violem às disposições destes
          Termos e Condições; (iii) se o usuário causar algum dano direto ou indireto à OPERADORA, seus usuários ou a
          terceiros; (iv) seja identificada, de forma direta ou indireta, a prática de atitudes fraudulentas através do
          uso da Plataforma; (v) seja averiguada a inadimplência do usuário, que se dá quando este último deixar de
          efetuar o pagamento de qualquer parcela devida em favor da OPERADORA ou Fornecedor nos termos firmados entre
          as partes; (vi) em outros casos onde a OPERADORA entenda necessário, por violação de normas jurídicas,
          incompatibilidade com a política da Plataforma, ou livre critério da OPERADORA.
        </p>
        <b>11. DAS CAMPANHAS PROMOCIONAIS</b>
        <p>
          A OPERADORA poderá realizar campanhas promocionais que garantem desconto no valor da compra, por meio de
          códigos promocionais ou outros meios. O regulamento de tais campanhas é definido única e exclusivamente pela
          OPERADORA, podendo ser alterado ou encerrado a qualquer momento
        </p>
        <p>
          Sobre essas campanhas, fica a critério do OPERADORA definir, entre outras coisas: (i) usuários que estão
          elegíveis a participar, (ii) ofertas que estão elegíveis a receber descontos adicionais, (iii) regras
          específicas para ativação de descontos, como valor mínimo da compra e quantidade de cupons, (iv) valor do
          desconto, (v) quantidade disponível de códigos promocionais.
        </p>
        <p>
          Cada uma das campanhas será regida por termos e condições específicos, cujas regras serão interpretadas a luz
          do presente Termos e Condições, regras jurídicas aplicáveis e boa fé das partes.
        </p>
        <b>12. INFORMAÇÕES SOBRE A PROPRIEDADE INDUSTRIAL E DIREITOS AUTORAIS:</b>
        <p>
          Ao aceitar estes Termos de Uso, o usuário reconhece e concorda que todo o conteúdo apresentado na Plataforma
          está protegido por direitos autorais, marcas, patentes ou outros direitos e leis de propriedade industrial e é
          propriedade exclusiva da OPERADORA. O usuário só pode usar o conteúdo conforme expressamente autorizado pela
          OPERADORA, ou seja, para o seu uso pessoal sem que isso signifique a entrega de qualquer licença da
          Plataforma. O usuário não pode copiar, reproduzir, modificar, republicar, carregar, publicar, transmitir ou
          distribuir quaisquer documentos ou informações da Plataforma de qualquer forma ou por qualquer meio, sem a
          permissão prévia por escrito da OPERADORA. O uso não autorizado dos materiais que aparecem na Plataforma pode
          violar direitos autorais, marcas registradas e outras leis aplicáveis e pode resultar em penalidades criminais
          ou civis. O usuário não deverá enviar à OPERADORA informações confidenciais, a menos que as Partes tenham
          concordado mutuamente por escrito. Eventuais ideias ou propostas não solicitadas enviadas pelo usuário à
          OPERADORA não reserva nenhum direito ao usuário.
        </p>
        <b>13. DO USO DAS INFORMAÇÕES</b>
        <p>
          Os dados levantados poderão também ser objeto de análise para fins de melhoramento da estratégia de negócios
          da página web, apoiada por ferramentas de inteligência de negócios e mineração de dados, que permitem adquirir
          conhecimentos prospectivos para fins de predição, classificação e segmentação.
        </p>
        <p>
          O usuário poderá exercer seu direito de conhecer, atualizar, modificar e suprimir os dados pessoais existentes
          nas bases de dados associadas à Plataforma. Para isto deverá realizar a solicitação de consulta, reclamação ou
          supressão ao endereço eletrônico servicioaocliente@rappi.com, com os detalhes das alterações a serem
          realizadas e entregando os documentos que a sustentam.
        </p>
        <p>
          A OPERADORA ou o Fornecedor poderão ser responsáveis pelo tratamento das informações pessoais levantadas
          através da página web, responsabilidade que poderá ser delegada a um terceiro, na qualidade de responsável ou
          encarregado das informações, garantindo por meio de contrato um adequado tratamento das mesmas, tudo
          explicitado na Política de Privacidade.
        </p>
        <b>14. DA LEGISLAÇÃO APLICÁVEL E FORO</b>
        <p>
          Para dirimir quaisquer controvérsias oriundas do presente Instrumento, as partes elegem o Foro Central da
          comarca da cidade de São Paulo – SP (renunciando a qualquer outro por mais privilegiado que seja), sendo
          aplicáveis as Leis da República Federativa do Brasil.
        </p>
        <p>São Paulo/SP</p>
      </>
    )}

    {country !== 'BR' && country !== '55' && (
      <>
        <section>
          <h1>TÉRMINOS Y CONDICIONES TRAVEL MOUSTACHE</h1>

          <ol className="main-list">
            <li style={{ listStyleType: 'none' }}>
              <h2>CONSIDERACIONES GENERALES</h2>
              <ol>
                <li>
                  Travel Moustache S.A.S. (en adelante “Travel Moustache o la Agencia”) es una agencia de viajes en
                  línea, identificada con Registro Nacional de Turismo (RNT) # 79000, con domicilio en la ciudad de
                  Bogotá, D.C., Colombia.
                </li>
                <li>
                  Travel Moustache permite a una gran cantidad de proveedores de servicios turísticos (en adelante
                  “Proveedores”) ofrecer y comercializar sus productos y/o servicios a los Usuarios/Consumidores de la
                  plataforma Rappi, quienes a su vez pueden realizar averiguaciones sobre alojamientos, cruceros,
                  vuelos, actividades y demás servicios turísticos (en adelante “Servicios Turísticos), así como
                  comparar y reservar dichos Servicios Turísticos en tiempo real y adquirirlos por separado o
                  combinados, armando y gestionando su viaje, de conformidad con sus intereses por medio de la
                  plataforma Rappi.
                </li>
                <li>
                  En el marco de sus actividades Travel Moustache opera únicamente como intermediario entre los
                  Usuarios/Consumidores y los Proveedores, entendiéndose que Travel Moustache no es el proveedor de los
                  Servicios Turísticos. Por lo anterior, el Usuario/Consumidor que contrata los Servicios Turísticos a
                  través de Travel Moustache, lo hace directamente con el Proveedor.
                </li>
                <li>
                  Se aclara que los presentes términos y condiciones no remplazan, modifican o suplen los términos y
                  condiciones que cada Proveedor establezca para el disfrute de los Servicios Turísticos que presta; por
                  esta razón, resulta indispensable que antes de adquirir cualquier Servicio Turístico por intermedio de
                  Travel Moustache, el Usuario/Consumidor consulte directamente las condiciones, especificaciones y
                  particularidades que cada Proveedor haya establecido para el Servicio Turístico que desea adquirir. Lo
                  anterior, en la medida en que Travel Moustache no establece, ni participa en la formulación de los
                  términos y condiciones que cada Proveedor maneja con relación a sus productos y servicios.
                </li>
                <li>
                  De igual manera, al hacer uso del botón “RappiTravel” dentro de la plataforma Rappi, el
                  Usuario/Consumidor acepta y garantiza que: (i) es mayor de edad, (ii) posee plena capacidad para la
                  celebración de contratos, (iii) está adquiriendo los Servicios Turísticos para su uso personal o para
                  quien le haya autorizado para actuar, (iv) toda la información proporcionada para la adquisición de
                  los Servicios Turísticos por medio de Travel Moustache es real, precisa, actual y completa, (v) acepta
                  haber leído, entendido y estar de acuerdo con los presentes términos y condiciones, (vi) en caso de
                  adquirir Servicios Turísticos con destino/escala en Cuba, no es ciudadano ni residente Norteamericano,
                  ni se encuentra sujeto a la jurisdicción de Estados Unidos.
                </li>
                <li>
                  Para los efectos de los presentes términos y condiciones, por Usuario/Consumidor se entenderá aquella
                  persona natural o jurídica que adquiere Servicios Turísticos por medio del botón “Netactica Corporate”
                  dentro de la plataforma Rappi. Por Pasajero se entenderá aquella persona natural o jurídica que
                  disfruta de los Servicios Turísticos adquiridos, entendiéndose que el Pasajero no necesariamente es el
                  Usuario/Consumidor. Se aclara que tanto los Usuarios/Consumidores como los Pasajeros deben dar
                  cumplimiento a los presentes términos y condiciones.
                </li>
              </ol>
            </li>

            <li value={1}>
              <h2>RESPONSABILIDAD</h2>
              <ol>
                <li>
                  Travel Moustache no se responsabiliza por ninguna clase de situación de fuerza mayor (accidentes,
                  huelgas, asonadas, terremotos, fenómenos climáticos o naturales, condiciones de seguridad, factores
                  políticos, negación de permisos de ingreso, asuntos de salubridad y cualquier otro), caso fortuito,
                  hecho exclusivo de la víctima, o de un tercero que se presenten antes o durante la prestación de los
                  Servicios Turísticos que demoren, interrumpan o impidan su pleno disfrute, ni tampoco por los riesgos
                  que para la salud e integridad representen los destinos turísticos elegidos por los
                  Usuarios/Consumidores, pues corresponde a su responsabilidad informarse y tomar medidas al respecto.
                  Para este efecto, se tendrán en cuenta las deducciones, penalidades, condiciones y gastos de
                  administración previamente establecidos por los Proveedores, cuando los Servicios Turísticos no sean
                  utilizados.
                </li>
                <li>
                  Travel Moustache no se responsabiliza personalmente ni de forma solidaria con el Proveedor, por las
                  sumas solicitadas por parte de los Usuarios/Consumidores, así como tampoco por los intereses que se
                  generen, en caso de que el Proveedor no realice el reembolso oportunamente. Lo anterior debido a que
                  Travel Moustache es un intermediario entre los Usuarios/Consumidores y los Proveedores.
                </li>
                <li>
                  El solo uso de la plataforma Rappi implica la aceptación de todas y cada una de las condiciones
                  generales y particulares incluidas en estos términos y condiciones. Su lectura le permitirá ejercer en
                  mejor forma sus derechos como consumidor. Le sugerimos imprimirlas y conservarlas, junto con el resto
                  de la documentación de viaje.
                </li>
                <li>
                  Las reservaciones y boletas para la participación en cruceros, eventos deportivos y culturales,
                  congresos, ferias, exposiciones y similares se sujetarán a las condiciones que señalen las empresas
                  organizadoras de tales eventos para cada plan. Dichas condiciones se informarán al Usuario/Consumidor
                  al momento de la compra. En las condiciones específicas de cada plan se indicará la cuantía de los
                  anticipos y el plazo para el pago de la suma por parte del Usuario/Consumidor. Por lo anterior, Travel
                  Moustache recomienda al Usuario/Consumidor revisar los términos y condiciones particulares aplicables
                  al Servicio Turístico que desea contratar.
                </li>
                <li>
                  Travel Moustache se reserva el derecho de hacer cambios en el itinerario, fechas de viaje, hoteles de
                  similar o superior categoría, transportes, ante circunstancias de fuerza mayor o caso fortuito.
                </li>
                <li>
                  Travel Moustache se limita a informar al Usuario/Consumidor sobre la documentación requerida para
                  facilitar su ingreso a los destinos nacionales e internacionales. Por lo anterior, es obligación del
                  Usuario/Consumidor verificar en la programación de su desplazamiento el cumplimiento de dichos
                  requisitos. Travel Moustache en ningún caso se responsabiliza si un país niega al pasajero el ingreso,
                  ni tampoco se hace cargo por los gastos personales que le acarree tal eventualidad.
                </li>
                <li>
                  Travel Moustache no se responsabiliza en ninguna circunstancia por la pérdida o demora de equipaje o
                  elementos personales del Usuario/Consumidor. El Usuario/Consumidor será el único responsable por la
                  custodia de su equipaje y objetos personales, entre los cuales se incluyen los documentos de viaje.
                </li>
              </ol>
            </li>

            <li>
              <h2>PROCESO DE RESERVA Y COMPRA</h2>
              <ol>
                <li>
                  Cuando el Usuario/Consumidor envía una solicitud de compra a través del botón “RappiTravel” dentro de
                  la plataforma Rappi (en adelante “Solicitud de Compra”), autoriza a Travel Moustache a gestionar su
                  reserva y a cursar el/los respectivo/s cargo/s a su cuenta o tarjeta. El Usuario/Consumidor debe
                  prestar atención a las comunicaciones posteriores, donde se le informará sobre los avances y estado de
                  su Solicitud de Compra. La confirmación de la compra depende del pago íntegro del precio y/o tarifa de
                  todos los Servicios Turísticos, y mientras no se confirme el pago total de la reserva, la Solicitud de
                  Compra quedará en suspenso y podría ser cancelada por el Proveedor. La confirmación definitiva de los
                  Servicios Turísticos y precios se producirá con la emisión del tiquete electrónico y/o voucher del
                  servicio.  La emisión del tiquete electrónico y/o voucher del servicio da fe de la aceptación de las
                  condiciones del Proveedor y la celebración del contrato suscrito entre el Proveedor y el Pasajero que
                  aparece en dicho tiquete electrónico y/o voucher del servicio.
                </li>
                <li>
                  Si la Solicitud de Compra quedará sujeta a confirmación, los valores pagados antes de la confirmación
                  serán recibidos bajo concepto de reserva. Si finalmente la Solicitud de Compra fuera rechazada por
                  cualquier motivo (por ejemplo, por saldo insuficiente en la tarjeta de crédito, por falta de
                  disponibilidad, por variación en la tarifa, entre otros), Travel Moustache procederá a informarle al
                  Usuario/Consumidor las opciones disponibles en caso de que desee insistir en la compra o reserva o, a
                  su requerimiento, le devolverá los importes abonados.
                </li>
              </ol>
            </li>

            <li>
              <h2>MEDIO DE PAGO Y TARIFAS</h2>
              <ol>
                <li>
                  Al realizar una reserva de uno o más Servicios Turísticos a través del botón “RappiTravel” dentro de
                  la plataforma Rappi, el Usuario/Consumidor debe abonar i) el precio o tarifa fijada por el Proveedor,
                  ii) los impuestos aplicables al Servicio Turístico; iii) el cargo de servicio “service fee” de Travel
                  Moustache, en caso de que aplique; y iv) la Tarifa Administrativa (conforme se define dicho término
                  más adelante).
                </li>
                <li>
                  Los medios y formas de pago disponibles para cada Servicio Turístico son informados al
                  Usuario/Consumidor al momento de solicitar la reserva a través del botón “RappiTravel” dentro de la
                  plataforma Rappi.
                </li>
                <li>
                  Para pagos con tarjetas de crédito:
                  <ol style={{ listStyleType: 'lower-alpha' }}>
                    <li>
                      El cargo de servicio “service fee” de Travel Moustache, en caso de que aplique, podría aplicarse
                      íntegro en la primera cuota a pesar de que el Usuario/Consumidor haya elegido la opción de pago en
                      cuotas para el resto del precio o tarifa.
                    </li>
                    <li>
                      Los intereses y/o impuestos que pudieran generar los pagos en cuotas, se suman al precio o tarifa
                      propuesto para el Servicio Turístico, y dicho total se divide por la cantidad de cuotas
                      seleccionada para el pago.
                    </li>
                    <li>
                      En caso de cancelaciones posteriores a la compra, siempre que las condiciones particulares del
                      Servicio Turístico lo permitan, Travel Moustache no reintegrará ni se hará responsable por los
                      intereses que la transacción original haya generado.
                    </li>
                    <li>
                      El precio por pagar puede depender del tipo de cambio, por lo que se recomienda al
                      Usuario/Consumidor tener esto en consideración para viajes internacionales.
                    </li>
                  </ol>
                </li>
                <li>
                  Cuando el Usuario/Consumidor adquiere una tarifa promocional, salvo indicación expresa en contrario,
                  en este tipo de tarifas no se aceptan cambios, cancelaciones o reembolsos del importe de la reserva.
                  El tiquete comprado con tarifa promocional debe ser usado en las condiciones en que fue comprado por
                  el Usuario/Consumidor. Solo aplicarán excepciones en los casos en que el Proveedor acepte de manera
                  expresa en sus términos y condiciones, el pago de alguna penalidad, por el cambio de las condiciones
                  del Servicio Turístico adquirido con una tarifa promocional. El Usuario/Consumidor será el responsable
                  de validar los términos y condiciones del Proveedor correspondiente.
                </li>
              </ol>
            </li>

            <li>
              <h2>REVERSIONES DE PAGO</h2>
              <p>
                El Decreto 587 de 2016 del Ministerio de Comercio, Industria y Turismo Colombiano le otorga al
                Usuario/Consumidor la facultad de solicitar la reversión de su pago, cuando la adquisición de productos
                turísticos se realice a través del Sitio web. Lo anterior, siempre que el pago se haya realizado con una
                tarjeta de crédito, débito o cualquier otro instrumento de pago, electrónico. Se aclara que si la compra
                corresponde a un tiquete aéreo, el Usuario/Consumidor no podrá acogerse a esta figura por expresa
                disposición de la regulación mencionada. En estos casos, el Usuario/Consumidor podrá solicitar reversión
                de pagos por cualquiera de las siguientes causales.
              </p>
              <ul>
                <li>Cuando fue objeto de fraude.</li>
                <li>Cuando el cargo generado sobre el medio de pago corresponde a una operación no solicitada.</li>
                <li>Cuando el producto y/o servicio adquirido no fue recibido.</li>
                <li>
                  Cuando el producto y/o servicio recibido no corresponde a lo solicitado (no cumple con las
                  características informadas o atribuidas a éste).
                </li>
                <li>Cuando el producto y/o servicio es defectuoso.</li>
              </ul>
              <p>
                El Usuario/Consumidor podrá solicitar la reversión parcial del pago de aquellos productos respecto de
                los cuales se presente alguno de los eventos mencionados anteriormente, expresando claramente cuál es el
                valor por el cual se solicita la reversión, el cual deberá corresponder al valor del producto o
                productos respecto de los cuales se presenta la causal.
              </p>
              <p>
                Para que proceda la reversión del pago, dentro los cinco (5) días hábiles siguientes a la fecha en que
                el Usuario/Consumidor tuvo noticia de la operación fraudulenta o no solicitada, o que recibió la
                confirmación de una compra no solicitada, deberá presentar queja ingresando todos los datos a través del
                botón denominado “Soporte Travel” y notificar de la reclamación al emisor del instrumento de pago
                electrónico utilizado para realizar la compra, el cual, en conjunto con los demás participantes del
                proceso de pago, procederá a reversar la transacción al Usuario/Consumidor. Se aclara que la reversión
                se verá reflejada en la cuenta del Usuario/Consumidor en el término determinado por el emisor del
                instrumento de pago. Travel Moustache no tiene injerencia sobre dicho término.
              </p>
              <p>
                Travel Moustache advierte al Usuario/Consumidor que en virtud de lo dispuesto por el artículo
                2.2.2.51.10 del Decreto 587 de 2016, si como consecuencia de su solicitud de reversión, el
                Usuario/Consumidor recibiera montos que exceden lo originalmente pagado, el Usuario/Consumidor será
                responsable de la devolución de los mismos. Es importante aclarar que de acuerdo a lo establecido en el
                artículo 2.2.2.51.12. del Decreto 587 de 2016, si se demuestra que el Usuario/Consumidor no se
                encontraba incurso en ninguna de las causales de reversión establecidas en la reclamación, Travel
                Moustache y/o el emisor de su instrumento de pagos podrán cargar definitivamente la transacción
                reclamada a su tarjeta o medio de pago.
              </p>
              <p>
                Como lo establece la regulación, Travel Moustache deja constancia que de demostrarse la mala fe del
                Usuario/Consumidor en el proceso de reversión será sancionado por la Superintendencia de Industria y
                Comercio, en los términos artículo 2.2.2.51.13, del Decreto 587 de 2016 hasta con cincuenta (50)
                salarios mínimos mensuales legales vigentes (SMMLV).
              </p>
            </li>

            <li>
              <h2>DERECHO DE RETRACTO</h2>
              <p>
                Conforme a lo establecido en el artículo 47 de la Ley 1480 de 2011 (Estatuto del Consumidor), para hacer
                efectivo el derecho de retracto, el Usuario/Consumidor deberá presentar la solicitud de retracto dentro
                de los cinco (5) días hábiles siguientes a la fecha en que realizó la compra. Lo anterior, siempre y
                cuando no haya comenzado a prestarse el Servicio Turístico con anterioridad a dicho término. Para
                ejercer el derecho de retracto el Usuario/Consumidor deberá informar a Travel Moustache por escrito. Se
                aclara que el Usuario/Consumidor podrá realizar la solicitud de retracto a través de los canales de
                comunicación dispuestos al interior de la Plataforma Rappi, a través del botón soporte al interior de
                “Netactica Corporate”, enviando un correo electrónico a{' '}
                <a href="mailto:servicioalclienteco@rappitravel.com">servicioalclienteco@rappitravel.com</a>, o llamando
                a la línea telefónica (1)3163525. Travel Moustache realizará el seguimiento de la solicitud ante el
                Proveedor y en caso de haber sido abonado, será el Proveedor, quien directamente deberá proceder con la
                devolución del dinero en la forma como lo tenga previsto en sus términos y condiciones y/o política
                corporativa.
              </p>
            </li>

            <li>
              <h2>CANCELACIONES</h2>
              <ol>
                <li>
                  Si el Usuario/Consumidor solicita un cambio o cancelación fuera de los plazos y procedimientos
                  establecidos por el Proveedor o por la ley, y la regulación específica de la tarifa seleccionada así
                  lo permitiera, Travel Moustache realizará las gestiones de presentación y seguimiento de la solicitud,
                  pero la decisión final será del Proveedor.  Se aclara que la forma de proceder y las condiciones
                  especiales que rigen para casos de cambios o cancelaciones en una reserva confirmada por el
                  Usuario/Consumidor son determinadas por los Proveedores, quienes podrán establecer multas o
                  penalidades aplicables para los cambios solicitados. Igualmente, se aclara que cada Proveedor define
                  sus penalidades sin intervención de Travel Moustache.
                </li>
                <li>
                  En el caso de devoluciones aprobadas por el Proveedor, se podrá generar una reversión a la misma
                  tarjeta con la cual se hizo la reserva, previa autorización del titular de la tarjeta. Si el pago fue
                  realizado en efectivo y/o transferencia bancaria, Travel Moustache requerirá los datos bancarios para
                  realizar el reembolso mediante transferencia bancaria. Los plazos de reembolso y/o de la reversión del
                  cargo dependerán de cada Proveedor.
                </li>
                <li>
                  El cargo de gestión y/o Tarifa Administrativa cobrada por Travel Moustache es de carácter no
                  reembolsable. En caso de cancelación de reservas confirmadas por cualquier motivo, este cargo de
                  gestión no será reintegrado al Usuario/Consumidor ya que corresponde a un servicio efectivamente
                  prestado por Travel Moustache. Así mismo, en el caso supuesto que el Usuario/Consumidor solicite el
                  cambio o la cancelación de un Servicio Turístico, Travel Moustache podrá cobrar un cargo de gestión
                  adicional.
                </li>
              </ol>
            </li>

            <li>
              <h2>DATOS PERSONALES</h2>
              <ol>
                <li>
                  Travel Moustache y Rappi INC, sus subsidiarias y/o filiales tratarán los datos de los
                  Usuarios/Consumidores de conformidad con la POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES
                  (https://legal.rappi.com/colombia/politica-de-proteccion-y-tratamiento-de-datos-personales-rappi-s-a-s/),
                  la Ley Estatutaria 1581 de 2012, el Decreto 1377 de 2013, el Decreto 886 de 2014 y las normas que las
                  modifiquen o adicionen.
                </li>
                <li>
                  Al ingresar los datos personales en la plataforma Rappi, el Usuario/Consumidor declara que dichos
                  datos son exactos, precisos y verdaderos, y asume el compromiso de actualizar dichos Datos Personales
                  conforme resulte necesario. Travel Moustache no se responsabiliza por la certeza de los Datos
                  Personales provistos por el Usuario/Consumidor, cuyos datos deberán coincidir en forma exacta con la
                  documentación de viaje.
                </li>
                <li>
                  El Usuario/Consumidor debe ingresar los datos fiscales exactos en el campo denominado “Datos de
                  Facturación” en el botón “Netactica Corporate”, en aras de que Travel Moustache pueda emitir la
                  correspondiente factura. En virtud de lo anterior, es responsabilidad del Usuario/Consumidor
                  asegurarse de que los datos ingresados sean exactos, precisos y verdaderos. Travel Moustache no será
                  responsable por la emisión de la factura con información errada proporcionada por el
                  Usuario/Consumidor. En caso de registrarse errores en los datos de la factura, el Usuario/Consumidor
                  podrá solicitar a través del área de soporte de Netactica Corporate, la corrección de la factura
                  dentro de los tres (3) días hábiles siguientes a la recepción de la misma.
                </li>
              </ol>
            </li>

            <li>
              <h2>NO PRESENTACIÓN</h2>
              <p>
                Si el Usuario/Consumidor o el Pasajero no se presentan a utilizar su reserva en la fecha y horarios
                indicados o llegan de forma tardía, éstos no tendrán derecho a exigir la devolución total o parcial del
                importe abonado.
              </p>
            </li>

            <li>
              <h2>PREVENCIÓN RESPECTO A EXPLOTACIÓN, ABUSO O TURISMO SEXUAL CON MENORES DE EDAD</h2>
              <p>
                En virtud del artículo 17 de la Ley 679 de 2001, la Resolución 3840 del 24 de diciembre de 2009, y el
                artículo 1 de la Ley 1336 de 2009, se establecen disposiciones para prevenir y contrarrestar la
                explotación sexual comercial, la pornografía, el turismo sexual y demás formas de abuso con menores de
                edad. Bajo ese entendido, cualquier incumplimiento a dichas disposiciones podría generar sanciones
                penales y administrativas conforme a las leyes aplicables. Igualmente, cada Proveedor en sus términos y
                condiciones determinará las medidas tendientes a prevenir cualquiera de estas conductas tipificadas como
                delitos en las leyes.
              </p>
            </li>

            <li>
              <h2>LICENCIAS Y MARCAS REGISTRADAS </h2>
              <ol>
                <li>
                  Travel Moustache opera a través de la plataforma Rappi de propiedad de RAPPI INC. quien posee las
                  autorizaciones correspondientes para el uso de las imágenes, gráficas, iconos, caracteres, música,
                  textos, software, videos y otros contenidos de la plataforma Rappi (en adelante, “contenido”), así
                  como de las codificaciones HTML, CGI, WS y otros códigos y textos en cualquier formato (en adelante,
                  “código”) utilizados para implementar la plataforma Rappi.
                </li>
                <li>
                  Ningún código o contenido de la plataforma Rappi podrá ser modificado, alterado, copiado, distribuido,
                  retransmitido, expuesto, utilizado, reproducido y/o publicado bajo ningún concepto.
                </li>
                <li>
                  Cualquier modificación o uso del contenido o código de la plataforma Rappi para propósitos diferentes
                  a los permitidos expresamente por Rappi S.A.S. o por Travel Moustache S.A.S., constituye una violación
                  de las leyes de derechos de autor (Copyright) y otros derechos de propiedad intelectual, así como a
                  las normas penales a que dé lugar la situación particular.
                </li>
              </ol>
            </li>
          </ol>
        </section>

        <section>
          <h1>CONSIDERACIONES ESPECÍFICAS DE LOS SERVICIOS TURÍSTICOS</h1>

          <ol className="main-list">
            <li>
              <h2>VUELOS</h2>
              <p>
                * Para efectos de esta sección, por Aerolínea se entenderá a la compañía encargada de prestar el
                servicio de transporte aéreo adquirido por el Usuario/Consumidor por medio del botón “Netactica
                Corporate” dentro de la plataforma Rappi.
              </p>
              <ol>
                <li>
                  Respecto de las tarifas promocionales, económicas y turistas: A través del botón “Netactica Corporate”
                  dentro de la plataforma Rappi, siempre se mostrará la disponibilidad de las tarifas más económicas
                  encontradas a través del sistema de distribución GDS. Por lo anterior, dichas tarifas contienen mayor
                  restricciones en las políticas de cambios, cancelaciones y reembolso, entendiéndose que en caso que el
                  Usuario/Consumidor y/o el Pasajero soliciten alguno de los procesos anteriormente mencionados, se
                  podrán generar sobrecostos, los cuales deberá ser asumidos por éstos. Se aclara que Travel Moustache
                  no se encuentra autorizada a modificar en ningún caso las regulaciones de los tiquetes aéreos.
                </li>
                <li>
                  Tarifa Administrativa: Los cargos por emisión, también conocidos como Tarifa Administrativa son
                  cobrados por Pasajero. Se aclara que por regulación de la Unidad Especial de la Aeronáutica Civil,
                  dicha Tarifa Administrativa no es reembolsable dado que se trata de un cobro obligatorio por la
                  expedición de tiquetes aéreos.
                </li>
                <li>
                  Desistimiento para tiquetes aéreos: El Usuario/Consumidor podrá desistir del viaje dando aviso a la
                  Aerolínea o a Travel Moustache con un plazo de al menos veinticuatro (24) horas calendario antes del
                  inicio de vuelo. Se aclara que este derecho sólo puede ser ejercido por el Usuario/consumidor. En este
                  caso, la Aerolínea aplicará una retención de acuerdo a la regla tarifaria aplicable sin que ésta
                  exceda el diez por ciento (10%) del valor de la tarifa base incluyendo el Q de Combustible. El
                  desistimiento no aplica para las tarifas promocionales, y el reembolso se hará efectivo dentro de los
                  treinta (30) días siguientes a la fecha de notificación a la forma original de pago.
                </li>
                <li>
                  Retrasos, modificaciones y/o cancelaciones de vuelos por las aerolíneas: El Usuario/Consumidor acepta
                  y reconoce que las aerolíneas están habilitadas a realizar modificaciones en los vuelos programados en
                  tanto las comunique a la autoridad, conforme a la regulación aplicable. En relación con lo anterior,
                  se aclara que Travel Moustache no interviene en las modificaciones que podrían sufrir los vuelos,
                  entendiéndose que en caso de presentarse alguna variación en los mismos, Travel Moustache le informará
                  al Usuario/Consumidor las alternativas disponibles y solo procederá a confirmar las modificaciones con
                  su aceptación. Cualquier reclamo, demanda o denuncia por la prestación del servicio escogido deberá
                  ser dirigida a la Compañía Aérea. Recuerde que son las aerolíneas las que prestan el servicio de
                  transporte. Los derechos del Usuario/Consumidor y los procedimientos para hacer efectivas las
                  devoluciones de dinero a que estos hechos den lugar, se regirán por las disposiciones legales
                  pertinentes y en particular, por las contenidas en el Reglamento Aeronáutico Colombiano (RAC) y la Ley
                  1480 de 2011. Cuando por razón de la tarifa o por cualquier otro motivo existan restricciones para
                  efectuar modificaciones a la reserva aérea, endosos o reembolsos; tales limitaciones se informarán en
                  su momento al Usuario/Consumidor.
                </li>
                <li>
                  El trámite del reembolso de un tiquete lo realiza la Aerolínea y el tiempo estimado de reintegro
                  depende de ésta, siempre y cuando el tiquete aéreo sea reembolsable. En caso de reembolso, se
                  aplicarán las normas y penalidades establecidas por cada Aerolínea con base en el tipo de tarifa y sus
                  restricciones. Así mismo, en el supuesto que el Usuario/Consumidor solicite la cancelación y el
                  reembolso del o los tiquetes, Travel Moustache podrá cobrar un cargo de gestión adicional, el cual se
                  realizará por tiquete a procesar.
                </li>
                <li>
                  Algunas tarifas económicas no permiten cambios, cancelaciones ni devoluciones, en caso en que -de
                  acuerdo con la reglamentación dispuesta por la línea aérea- la tarifa seleccionada por el
                  Usuario/Consumidor permita cambios, cancelaciones y/o devoluciones, la Aerolínea podrá aplicar cobros
                  adicionales tales como penalidades y diferencia de tarifa (resultado de la diferencia entre la tarifa
                  originalmente comprada y la nueva tarifa según disponibilidad al momento de efectuar el cambio). Se
                  aclara que los cambios se deben realizar en las mismas clases emitidas o bien en clases superiores. En
                  caso de cancelación y reembolso, Travel Moustache realizará la gestión y seguimiento de la solicitud
                  frente a la Aerolínea y el Usuario/Consumidor. Además, tanto en el caso de cambios como de
                  cancelaciones, Travel Moustache podrá cobrar un cargo de gestión adicional.
                </li>
                <li>
                  En el servicio aéreo se considera menor a una persona que a la fecha de viaje no haya cumplido los 12
                  años de edad. Con base en lo anterior, se informa a continuación la clasificación de niños en el
                  transporte aéreo con base a su edad:
                  <ul>
                    <li>
                      Infantes: Es todo aquel niño que no ha cumplido los dos (2) años a la fecha de vuelo, y viaja sin
                      ocupar silla. Se aclara que el infante debe estar siempre acompañado por un adulto, y debe ser
                      cargado en el regazo por el adulto responsable. Al infante le será emitido un tiquete, aunque éste
                      no haya pagado tarifa alguna en vuelos domésticos. En tal caso que el adulto desee que infante
                      ocupe asiento, éste deberá realizar el pago del boleto de transporte aéreo y deberá llevar una
                      silla de infante aprobada por las normas internacionales como apta para usarse en una aeronave.
                    </li>
                    <li>
                      Niños: Son aquellos niños que ya han cumplido los dos (2) años de edad y no han cumplido los doce
                      (12) años a la fecha del vuelo, los niños entre estas edades ocupan asiento y pagan la tarifa
                      informada por la Aerolínea.
                    </li>
                  </ul>
                </li>
                <li>
                  Se considerará “menor no acompañado” a aquel que viaje sin al menos uno de sus padres o tutores
                  legales. Las Aerolíneas pueden ofrecer servicios de asistencia y acompañamiento (con costo) que, según
                  el caso, podrán ser obligatorios u opcionales para aquellos menores que viajen sin acompañante. Sin
                  embargo, Travel Moustache no ofrece este tipo de servicios y no podrá asegurar el efectivo embarque
                  del menor en el caso de que la exigencia fuera obligatoria. Los menores de entre 2 y 5 años, deberán
                  viajar obligatoriamente acompañados por sus padres o responsables a cargo. Normalmente el servicio de
                  “menor no acompañado” es obligatorio para niños de entre 5 y 11 años, y opcional para niños de entre
                  12 y 17 años. El servicio no está disponible para niños que requieran certificación médica para
                  viajar, que no puedan alimentarse y/o que no sean capaces de cubrir sus necesidades básicas de
                  higiene, y no está disponible para itinerarios con escalas o cambios de avión. El Usuario/Consumidor y
                  el Pasajero son responsables de consultar la política específica de la Aerolínea.
                </li>
                <li>
                  <p>
                    De acuerdo con lo establecido en el artículo 110 del Código de Infancia y Adolescencia modificado
                    por el artículo 9 de la Ley 1878 de 2018, Travel Moustache informa lo siguiente:
                  </p>
                  <blockquote>
                    “Cuando un niño, una niña o un adolescente que tiene residencia en Colombia vaya a salir del país
                    con uno de los padres o con una persona distinta a los representantes legales deberá obtener
                    previamente el permiso de aquel con quien no viajare o el de aquellos, debidamente autenticado ante
                    notario o autoridad consular. Dicho permiso deberá contener el lugar de destino, el propósito del
                    viaje y la fecha de salida e ingreso de nuevo al país.”
                  </blockquote>
                  <p>
                    En caso de realizar un viaje al extranjero con menores de edad, Travel Moustache le recomienda al
                    Usuario/Consumidor verificar si los menores de edad que viajan cuentan con el nuevo pasaporte, en
                    este caso el adulto responsable deberá presentar ante las Autoridades de Migración en Colombia,
                    fotocopia auténtica y legible del registro civil de nacimiento. Adicionalmente, en cumplimiento con
                    lo establecido por la Unidad Administrativa Especial de la Aeronáutica Civil (UAEAC), Travel
                    Moustache le informa al Usuario/Consumidor que en los vuelos nacionales la presentación de la copia
                    del original del Registro Civil de los menores de 0 a 7 años al momento de viajar por modo aéreo es
                    obligatorio, de lo contrario, los menores no podrán viajar a destinos nacionales.
                  </p>
                </li>
                <li>
                  Los servicios especiales son aquellos servicios que se brindan con base en las necesidades del
                  Usuario/Consumidor o del Pasajero (en adelante “Servicios Especiales”). Dentro de la categoría de
                  Servicios Especiales se incluye, entre otros, el servicio de silla de ruedas, alimentación especial
                  abordo, mascotas en cabina y bodega, y menores sin acompañante. Dichos Servicios Especiales deben ser
                  solicitados por el Usuario/Consumidor a Travel Moustache con mínimo setenta y dos (72) horas
                  calendario de antelación a la fecha del vuelo. Se aclara que los Servicios Especiales están sujetos a
                  confirmación por parte de las Aerolíneas con base en la disponibilidad, y en algunas ocasiones, estos
                  Servicios Especiales pueden generar costos adicionales.
                </li>
                <li>
                  Las Aerolíneas tienen diferentes políticas de franquicia de equipaje. Lo usual en los vuelos
                  nacionales es de 8 kg y en los internacionales de 23 kg. Sin embargo, esto puede variar según la
                  Aerolínea, y la clase en que viaje el Pasajero, entendiéndose que algunas tarifas no incluyen
                  franquicia de equipaje. Travel Moustache no se responsabiliza por robo, hurto y/o pérdida de equipaje
                  y demás efectos personales de los Pasajeros. En caso de pérdida o deterioro de equipaje, el Pasajero
                  debe dirigirse a las oficinas de atención al cliente de la Aerolínea y realizar el correspondiente
                  reclamo. En todo caso el Usuario/Consumidor y el Pasajero deberán informarse sobre esto antes de
                  viajar.
                </li>
                <li>
                  Si el Usuario/Consumidor no se presenta a utilizar su reserva en la fecha y horarios indicados (o
                  llega con retraso), el Usuario/Consumidor no tendrá derecho a exigir la devolución total o parcial del
                  importe abonado (en adelante “No Show”). Igualmente, si el Usuario/Consumidor no va a utilizar su
                  reserva en todo o en parte o si va a llegar con retraso a utilizar su reserva, deberá comunicarlo
                  previamente a Travel Moustache para conocer las restricciones aplicables.
                </li>
                <li>
                  El Usuario/Consumidor deberá abstenerse de generar más de una reserva para el mismo destino- pasajero-
                  fecha - hora y Aerolínea. Esto se considera una mala práctica de duplicidad que puede ocasionar una
                  cancelación de reserva por parte de la Aerolínea.
                </li>
                <li>
                  Los tiquetes “SOLO IDA”: Por disposiciones migratorias de cada país, en caso de que el Pasajero tenga
                  un tiquete únicamente de ida, y éste no sea residente del país de destino, podrá ser requerido por las
                  autoridades migratorias a justificar las razones por las que no cuenta con un tiquete de regreso. En
                  ese caso, el Usuario/Consumidor deberá consultar al Consulado o Embajada correspondiente antes de
                  efectuar la reserva. Las Aerolíneas también podrán exigir esta documentación antes de embarcar.
                </li>
                <li>
                  La responsabilidad en el transporte aéreo se encuentra regulada por la Normativa Aeronáutica. En
                  virtud de lo anterior, si el Usuario/Consumidor desea realizar un reclamo respecto del contrato de
                  transporte aéreo celebrado entre éste y la Aerolínea, puede efectuarlo ante la Aeronáutica Civil
                  Colombiana,
                  <a target="_blank" rel="noopener noreferrer" href="https://www.aerocivil.gov.co">
                    www.aerocivil.gov.co
                  </a>
                  , organismo encargado de regular, vigilar, fiscalizar y certificar la actividad aeronáutica comercial
                  en Colombia.
                </li>
              </ol>
            </li>

            <li>
              <h2>HOTELES</h2>
              <ol>
                <li>
                  Las tarifas hoteleras exhibidas en el botón “Netactica Corporate” dentro de la plataforma Rappi
                  estarán sujetas a la acomodación seleccionada por el Usuario/Consumidor. Las políticas de cancelación,
                  penalidades y restricciones aplicables a la reserva o paquete que desea adquirir el
                  Usuario/Consumidor, serán definidas por parte del Proveedor.
                </li>
                <li>
                  La información específica del servicio hotelero como nombre, ubicación, categorización, horarios de
                  check-in y check-out, y servicios incluidos se encuentra suficientemente detallada en la plataforma
                  Rappi. Los Proveedores son responsables exclusivos de actualizar las tarifas, la disponibilidad y los
                  otros datos que aparecen en la plataforma Rappi.
                </li>
                <li>
                  Recuerde que, si el Usuario/Consumidor no se presenta en el alojamiento en la fecha y horario
                  correspondientes, el alojamiento podrá cancelar su reserva y considerarla como No Show. En dicho caso,
                  el Usuario/Consumidor no tendrá derecho a exigir el reembolso total o parcial del importe abonado. Si
                  por alguna circunstancia el Usuario/Consumidor va a llegar fuera de los horarios indicados, debe
                  comunicarse previamente con el alojamiento y/o con Travel Moustache.
                </li>
                <li>
                  El Usuario/Consumidor podrá solicitar cambios y/o cancelaciones siempre que las condiciones y
                  políticas de la tarifa adquirida lo permita. Cualquier excepción a dichas condiciones deberá ser
                  autorizada por el alojamiento. Travel Moustache no se encuentra autorizada a modificar en ningún caso
                  las políticas y/o condiciones de la reserva.
                </li>
                <li>
                  Los extranjeros no residentes en Colombia están exentos de tasas/impuestos hoteleros en Colombia
                  acreditando el ingreso al país en un periodo no mayor a treinta (30) días, contados desde la fecha en
                  que se registraron en el alojamiento. En virtud de lo anterior, éstos solo tendrán que pagar el seguro
                  hotelero el cual es opcional, y en caso de requerirlo, deberán efectuar el pago del mismo al
                  alojamiento directamente. Por el contrario, los Pasajeros colombianos deben pagar en el alojamiento
                  las tasas y el seguro hotelero opcional en caso de contratarlo. Esta validación se realizará
                  directamente en el alojamiento.
                </li>
                <li>
                  Travel Moustache informa que la actividad de los alojamientos domiciliados en la República de Colombia
                  se encuentra regulada por un conjunto de normas, entre ellas, la Ley 1480 de 2011, la Ley 300 de 1996
                  (Ley General del Turismo), y sus decretos reglamentarios, además de las disposiciones especiales
                  establecidas por el Ministerio de Comercio, Industria y Turismo, y demás autoridades regulatorias y de
                  defensa del consumidor colombiano. Si el Usuario/Consumidor desea realizar un reclamo respecto del
                  servicio brindado por el alojamiento, puede efectuarlo directamente ante los organismos previamente
                  expuestos. Para esto, puede ingresar a: www.mincit.gov.co/ y/o www.sic.gov.co.
                </li>
                <li>
                  Travel Moustache podrá solicitar una opinión o reseña al Usuario/Consumidor una vez este haya
                  utilizado los servicios de alojamiento, y está podrá ser publicada, siempre y cuando, no incumpla con
                  alguna de las siguientes condiciones: a) Haga mención a términos discriminatorios o racistas; b)
                  Utilice lenguaje ofensivo, violento o malintencionado; c) Realice amenazas en contra de Travel
                  Moustache, su matriz, subsidiarias y/o filiales, del alojamiento, su personal o de otro
                  Usuario/Consumidor; d) Utilice expresiones obscenas o sexualmente explícitas; y e) Exponga información
                  como páginas web, números de teléfono, direcciones de correo electrónico datos de tarjeta de crédito o
                  información personal privada.
                </li>
              </ol>
            </li>

            <li>
              <h2>PAQUETES</h2>
              <ol>
                <li>
                  A través de la sección denominada “Paquetes” dentro del botón “Netactica Corporate” en la plataforma
                  Rappi, el Usuario/Consumidor tendrá la posibilidad de comprar diferentes productos de viaje en un
                  único proceso de compra. En virtud de lo anterior, el Usuario/Consumidor podrá sumar todos los
                  Servicios Turísticos que considere y, una vez seleccionados, podrá realizar un único pago por dichos
                  Servicios Turísticos.
                </li>
                <li>
                  Cada Servicio Turístico seleccionado por el Usuario/Consumidor para armar su paquete establece sus
                  propias condiciones de cambio y/o cancelación definidas por cada Proveedor. En razón de lo anterior,
                  la modificación y/o cancelación de un Servicio Turístico no afecta, en modo alguno a los demás
                  Servicios Turísticos contratados los cuales se regirán por sus propias condiciones, y deberán ser
                  modificados y/o cancelados individualmente siempre que las condiciones del Proveedor lo permitan.
                </li>
              </ol>
            </li>

            <li>
              <h2>ACTIVIDADES</h2>
              <ol>
                <li>
                  Se entienden por “Actividades” la contratación de excursiones, traslados o atracciones, entre otras
                  que ofrezcan los Proveedores.
                </li>
                <li>
                  Las Actividades pueden sufrir modificaciones en horarios y puntos de partida. Es responsabilidad del
                  Usuario/Consumidor confirmar con previa anticipación esta información con el Proveedor. La información
                  de contacto estará disponible en el voucher de confirmación. Travel Moustache no será responsable por
                  la omisión de este procedimiento por parte del Usuario/Consumidor.
                </li>
                <li>
                  En los casos en los que una Actividad contratada sea una de riesgo, el Usuario/Consumidor asume el
                  riesgo de participar en la Actividad.
                </li>
              </ol>
            </li>

            <li>
              <h2>ALQUILER DE AUTOS</h2>
              <ol>
                <li>
                  El servicio de alquiler de auto se ofrecerá dentro del botón “Netactica Corporate”. El periodo de
                  duración del servicio dependerá de las fechas seleccionadas por el Usuario/Consumidor en el proceso de
                  compra.
                </li>
                <li>
                  La tarifa de alquiler de auto incluye kilometraje ilimitado y seguros mínimos requeridos en el
                  destino. Los servicios adicionales requeridos por el Usuario/Consumidor deberán ser agregados a la
                  compra. Se entiende por servicios adicionales, entre otros, GPS, Wifi, seguros/coberturas adicionales,
                  entre otros.
                </li>
                <li>
                  La tarifa de alquiler de auto no incluye impuestos o tasas locales a menos que sea explícitamente
                  informado por el Proveedor, así como tampoco el pago de multas, infracciones, servicio de grúas,
                  combustible, entrega de auto en otra ciudad, peajes ni cualquier otro servicio adicional, a menos que
                  este haya sido contratado con el Proveedor.
                </li>
                <li>
                  Se aplicarán las condiciones y requisitos de edad, permisos y calificación crediticia vigentes y
                  necesarias para la prestación del servicio de alquiler de auto. Cada Proveedor especificará estas
                  condiciones, las cuales deben ser consultadas por el Usuario/Consumidor.
                </li>
                <li>
                  La reserva de un auto a través del botón “Netactica Corporate” dentro de la plataforma Rappi, se
                  realiza para una clase de auto, no para vehículos de marcas, años o modelos específicos.
                </li>
                <li>
                  Las solicitudes de cambios o cancelaciones estarán sujetas a las políticas informadas por el
                  Proveedor. Estas solicitudes deberán ser notificadas a Travel Moustache con una anticipación no menos
                  a veinticuatro (24) horas antes de la fecha de iniciación del alquiler.
                </li>
                <li>
                  El Usuario/Consumidor deberá presentar una tarjeta de crédito a nombre del conductor. El Proveedor
                  podrá realizar un bloqueo correspondiente al monto de la garantía. Igualmente, éste podrá negar la
                  prestación del servicio de alquiler de auto en caso de no presentarse la garantía mediante tarjeta de
                  crédito.
                </li>
                <li>
                  La intermediación prestada por parte de Travel Moustache en lo referente al alquiler o renta de
                  automóviles en la República de Colombia, está regulada por un conjunto de normas, entre ellas, el
                  Código Civil, el Código de Comercio, la Ley 1480 de 2011 (Estatuto del Consumidor), la Ley 300 de 1996
                  (Ley General del Turismo), y sus decretos reglamentarios, además de las disposiciones especiales
                  establecidas por el Ministerio de Comercio, Industria y Turismo y las demás autoridades regulatorias,
                  como la Superintendencia de Industria y Comercio Colombiana.
                </li>
              </ol>
            </li>

            <li>
              <h2>TRANSPORTE TERRESTRE Y/O BUSES</h2>
              <p>
                * Para efectos de esta sección Empresa de Autobuses será aquella que contrata el Usuario/Consumidor para
                la prestación del servicio de transporte terrestre o autobús.
              </p>
              <ol>
                <li>
                  Una vez confirmada la solicitud de compra por medio de correo electrónico, el Usuario/Consumidor
                  recibirá a su correo electrónico registrado en la plataforma Rappi, el voucher del Servicio Turístico,
                  el cual deberá imprimir y llevar a la terminal de transporte. Al momento de viajar, el Pasajero debe
                  recoger el boleto en el mostrador del Proveedor, el cual para efectos de esta sección se denominará
                  “Empresa Transportadora”. Se aclara que este proceso deberá ser realizado por el Pasajero antes de
                  abordar. Igualmente, se aclara que el Pasajero deberá presentarse en el mostrador, por regla general,
                  con una antelación de mínimo una (1) hora sobre el horario de salida previsto, entendiéndose que en
                  caso de no presentarse y/o no presentarse con el tiempo suficiente, el Usuario/Consumidor y el
                  Pasajero no tendrán derecho a exigir el reembolso total o parcial del importe abonado. El
                  Usuario/Consumidor y el Pasajero deberán consultar las exigencias de la Empresa de Autobuses
                  contratada.
                </li>
                <li>
                  Adicionalmente, el Pasajero deberá contar con la documentación de viaje requerida. En caso de que los
                  datos registrados en el boleto no coincidan con la documentación de viaje que se presenta antes de
                  subir al autobús, el Pasajero no podrá viajar. Las Empresas de Autobuses se reservan el derecho de
                  brindar el Servicio Turístico adquirido mediante otra empresa cuando por razones técnicas u
                  operativas, se vean imposibilitadas a hacerlo con sus unidades. Sin perjuicio de lo anterior, las
                  Empresas de Autobuses deben respetar el precio, calidad y categoría de servicio adquirida por el
                  Usuario/Consumidor, salvo que la modificación se presente con ocasión de un evento de fuerza mayor o
                  caso fortuito.
                </li>
                <li>
                  Los niños menores de 9 años no pueden viajar solos bajo ninguna circunstancias. Los niños de 9 años de
                  edad pueden viajar únicamente acompañados de otra persona, quien por lo menos debe tener 16 años de
                  edad. Los niños de 10 años en adelante pueden viajar sin acompañante. La Empresa Transportadora podrá
                  solicitar el documento de identificación para comprobar la edad del menor. Todo niño menor de 18 años
                  que viaje sin acompañante debe ser transportado con el permiso de viaje correspondiente, para lo cual
                  deberá diligenciarse la autorización de viaje adjuntando copia del documento de identidad de quien
                  autoriza y del menor. Se aclara que la autorización de viaje debe ser gestionada por el Pasajero
                  directamente.
                </li>
                <li>
                  Franquicia de Equipaje: Las Empresas Transportadoras tienen diferentes políticas de franquicia de
                  equipaje. Estas podrán variar según la Empresa Transportadora y la clase en que se viaje, algunas
                  tarifas no incluyen franquicia de equipaje. El Usuario/Consumidor deberá consultarlas antes de viajar.
                </li>
                <li>
                  Travel Moustache no se hace responsable por pérdida o daños sufridos por objetos de valor
                  extraordinario que el Pasajero lleve consigo. Las Empresas Transportadoras tampoco son responsables
                  por la pérdida de equipaje de mano y de los demás efectos personales que hayan quedado bajo la
                  custodia del Pasajero, salvo culpa de la Empresa Transportadora.
                </li>
                <li>
                  Por disposiciones migratorias de cada país, en caso de que el Pasajero cuente con un pasaje únicamente
                  de ida, y éste no sea residente del país de destino, podrá ser requerido por las autoridades
                  migratorias a justificar las razones por las que no cuenta con un pasaje de regreso. El
                  Usuario/Consumidor deberá consultar al Consulado o Embajada correspondiente antes de efectuar la
                  reserva.
                </li>
              </ol>
            </li>
          </ol>
        </section>
      </>
    )}
  </>
);

export default Terms;
